import { DomainModel } from 'domains/models';
import EventPaymentLineItem from '../event_payment_line_item';
import { Currency } from '../service_price/currency';
import { TaxInclusive } from '../tax_rate/tax_inclusive';
import { PaymentMethod } from './payment_method';

export default class EventPayment extends DomainModel {
  eventId: number;
  paymentMethod: PaymentMethod;
  stripePaymentIntentId: string;
  receiptUrl: string | null;
  items: EventPaymentLineItem[];
  totalAmount: number;
  currency: Currency | null;

  constructor(props: any) {
    super(props);
    this._className = 'EventPayment';
    this.eventId = props.eventId;
    this.paymentMethod = props.paymentMethod;
    this.stripePaymentIntentId = props.stripePaymentIntentId;
    this.receiptUrl = props.receiptUrl;
    this.items = props.items;
    this.totalAmount = props.totalAmount;
    this.currency = props.currency;
  }

  static permited = ['stripePaymentIntentId', 'receiptUrl'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  calcSubTotalAmount() {
    let amount = 0;
    this.items.forEach((i) => {
      amount += i.unitAmount;
    });
    return amount;
  }

  calcTotalAmount() {
    let amount = 0;
    this.items.forEach((item) => {
      amount += item.unitAmount;
      if (item.taxInclusive === TaxInclusive.Exclusive) {
        amount += item.taxAmount;
      }
    });
    return amount;
  }

  calcTotalInclusiveTaxAmount() {
    let amount = 0;
    this.items.forEach((i) => {
      if (i.taxInclusive === TaxInclusive.Inclusive) {
        amount += i.taxAmount;
      }
    });
    return amount;
  }

  calcTotalExclusiveTaxAmount() {
    let amount = 0;
    this.items.forEach((i) => {
      if (i.taxInclusive === TaxInclusive.Exclusive) {
        amount += i.taxAmount;
      }
    });
    return amount;
  }

  isValid() {
    super.beforeValidate();
    const p = '';

    return super.isValid();
  }
}
